import sc from 'styled-components';

import React from 'react';
export default sc.div`
  width: ${props => props.width || 300}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  `;
